"use strict";
var ko = require("knockout");
ko.bindingHandlers["valueWithInit"] = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var observable = valueAccessor();
        var value = element.value;
        if (!ko.isWriteableObservable(observable)) {
            throw new Error("Observable should be writeable");
        }
        if (value) {
            observable(value);
        }
        else if (element.type === "date" && element.defaultValue) {
            value = new Date(element.defaultValue);
            observable(value);
            setTimeout(function () {
                var datepicker = $(element).data("kendoDatePicker");
                datepicker.value(value);
            }, 100);
        }
        var bindings = {
            value: observable
        };
        var valueUpdate = allBindings.get("valueUpdate");
        if (valueUpdate) {
            bindings["valueUpdate"] = valueUpdate;
        }
        ko.applyBindingsToNode(element, bindings, viewModel);
    }
};
//# sourceMappingURL=ko.valueWithInit.js.map